/* eslint-disable no-restricted-globals */
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';

// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { LoadingButton } from '@mui/lab';
import { Card, Grid, Stack, Container } from '@mui/material';
// routes
import axiosInstance from '../../../utils/axios';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from '../../../routes/paths';
import { FormProvider, RHFSelect, RHFTextField } from '../../../components/hook-form';

export default function AddDorm() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const NewSubSchema = Yup.object().shape({
    name: Yup.string().required('plan_name is required'),
    price: Yup.string().required('price is required'),
    duration_time: Yup.string().required('Duration Time is required'),
    duration_period: Yup.string().required('Duration Period is required'),
    description: Yup.string().required('Description is required'),
  });

  const defaultValues = useMemo(
    () => ({
      name: '',
      price: '',
      duration_time: '',
      duration_period: '',
      description: '',
    }),
    //  eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const methods = useForm({
    resolver: yupResolver(NewSubSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = methods;

  console.log(errors)
  const OnSubmit = async (data) => {
    console.log(data);
    try {
      const dorm = new FormData();
      dorm.append('name', data?.name);
      dorm.append('price', data?.price);
      dorm.append('duration_time', data?.duration_time);
      dorm.append('duration_period', data?.duration_period);
      dorm.append('description', data?.description);
      
      await axiosInstance.post('package', dorm)
        .then((response) => {
          console.log(response?.data);
          if (response?.data?.status === true) {
            enqueueSnackbar('Subscription Created Successfully');
            reset();
            navigate(PATH_DASHBOARD.dorm.dorm);
          }
        });
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: 'error',
      });
      console.error(error);
    }
  };

  return (
    <Container maxWidth="sm">
      <HeaderBreadcrumbs heading="Add Subscription" links={[{ name: '', href: '' }]} />
      <Card>
        <FormProvider methods={methods} onSubmit={handleSubmit(OnSubmit)}>
          <Grid container spacing={1}>

            <Grid item xs={12} md={12}>
              <Card sx={{ p: 3 }}>
                <Stack spacing={3}>
                  <RHFTextField name="name" label="Plan_name" InputLabelProps={{ shrink: true }} />
                  <RHFTextField name="price" label="Price" type="number" InputLabelProps={{ shrink: true }} />
                  <RHFTextField name="duration_time" type="number" label="Duration Time" InputLabelProps={{ shrink: true }} />

                <RHFSelect name="duration_period" label="Duration Period" placeholder="Select Status">
                  <option value="day">Day</option>
                  <option value="week">Week</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </RHFSelect>
                  <RHFTextField name="description" type="text" label="Description" InputLabelProps={{ shrink: true }} />


                  <Grid item xs={6} md={6}>
                    <LoadingButton type="submit" variant="contained" size="large" loading={isSubmitting}>
                      Create Subscription
                    </LoadingButton>
                  </Grid>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </FormProvider>
      </Card>
    </Container>
  );
}
